module.exports = __webpack_public_path__ + "img/img_42@2x.ca1e3eb4.png";